"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testSupplyYesterdayGas = exports.testSupplyYesterday = exports.testGasSupply = exports.testElecSupplyEnd = exports.testElecSupplyStartInFuture = exports.testElecSupply2 = exports.testElecSupply1AusTimezone = exports.testElecSupply1 = exports.testMeterRegisterConfigChangeOnlyAfter = exports.testMeterRegisterConfigChangeOnlyBefore = exports.testMeterRegisterConfigChange = exports.testMeterPeakOffpeakEveningWeekend = exports.testMeterHeat = exports.testMeterGas = exports.testSmartMeterSolarControlledLoad1 = exports.testSmartMeterSolarInterval = exports.testSmartMeterInterval = exports.testSmartMeter = exports.testMeterMultipleRegistersRemoved = exports.testMeterSingleRegisterRemoved = exports.testMeterSingleRegisterSolar = exports.testMeterMultipleRegistersDuplicate = exports.testMeterMultipleRegisters = exports.testMeterSingleRegister = exports.middleOfLastMonthDate = exports.over12MonthsReadDate = exports.todayReadDate = exports.yesterdayReadDate = exports.fourthReadDate = exports.thirdReadDate = exports.secondReadDate = exports.openingReadDate = exports.supplyStartDateYesterday = exports.supplyStartDateInFuture = exports.supplyEndDate = exports.supplyStartDate = exports.toFixedUTCIsoString = exports.testMsnHeat = exports.testMsnGas = exports.testMsnSolar = exports.testMsn4 = exports.testMsn3 = exports.testMsn2 = exports.testMsn1 = exports.testSprnGas = exports.testSprn2 = exports.testSprn1 = exports.testAccountId1 = exports.universalTradMeterType = exports.universalSmartMeterType = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../kapi/v1/__generated__/");
// These two meter types (basic and s2) will currently work for both retailers
// This allows test scenarios to work for both retailers
// Long term: request isSmart flag from MARS and do not query for meterType directly
exports.universalSmartMeterType = 's2';
exports.universalTradMeterType = 'basic';
exports.testAccountId1 = 'testAccountId1';
exports.testSprn1 = 'testSprn1';
exports.testSprn2 = 'testSprn2';
exports.testSprnGas = 'testSprnGas';
exports.testMsn1 = 'testMsn1';
exports.testMsn2 = 'testMsn2';
exports.testMsn3 = 'testMsn3';
exports.testMsn4 = 'testMsn4';
exports.testMsnSolar = 'testMsnSolar';
exports.testMsnGas = 'testMsnGas';
exports.testMsnHeat = 'testMsnHeat';
// IMPORTANT
// For fixtures, manually create ISO format, don't use .toISOString
// causes differences between local and CI since they're in different timezones
// and toISOString is always converted to UTC
// so creates a bug where read is set to the previous day when we're in BST
function toFixedUTCIsoString(date, hour) {
    if (hour === void 0) { hour = '00'; }
    return "".concat((0, date_fns_1.format)(date, 'yyyy-MM-dd'), "T").concat(hour, ":00:00.000Z");
}
exports.toFixedUTCIsoString = toFixedUTCIsoString;
//==== Dates ====//
exports.supplyStartDate = (0, date_fns_1.format)((0, date_fns_1.subMonths)((0, date_fns_1.startOfToday)(), 6), 'yyyy-MM-dd');
exports.supplyEndDate = (0, date_fns_1.format)(toFixedUTCIsoString((0, date_fns_1.subMonths)((0, date_fns_1.startOfToday)(), 2)), 'yyyy-MM-dd');
exports.supplyStartDateInFuture = (0, date_fns_1.format)((0, date_fns_1.addDays)((0, date_fns_1.startOfToday)(), 5), 'yyyy-MM-dd');
exports.supplyStartDateYesterday = (0, date_fns_1.format)((0, date_fns_1.subDays)((0, date_fns_1.startOfToday)(), 1), 'yyyy-MM-dd');
exports.openingReadDate = toFixedUTCIsoString((0, date_fns_1.subMonths)((0, date_fns_1.startOfToday)(), 6));
exports.secondReadDate = toFixedUTCIsoString((0, date_fns_1.addDays)(exports.openingReadDate, 1));
exports.thirdReadDate = toFixedUTCIsoString((0, date_fns_1.addDays)(exports.openingReadDate, 2));
exports.fourthReadDate = toFixedUTCIsoString((0, date_fns_1.addDays)(exports.openingReadDate, 3));
exports.yesterdayReadDate = toFixedUTCIsoString((0, date_fns_1.subDays)((0, date_fns_1.startOfToday)(), 1));
exports.todayReadDate = toFixedUTCIsoString((0, date_fns_1.startOfToday)());
exports.over12MonthsReadDate = toFixedUTCIsoString((0, date_fns_1.subMonths)((0, date_fns_1.startOfToday)(), 13));
exports.middleOfLastMonthDate = toFixedUTCIsoString((0, date_fns_1.subMonths)((0, date_fns_1.startOfToday)().setDate(15), 1));
var defaultRegister = {
    unitMeasurement: 'KWH',
    registerStartDate: exports.openingReadDate,
    registerEndDate: null,
};
//==== Test Registers ====//
var anytime = __assign({ registerId: '0', timingCategory: __generated__1.SupplyPointTimingCategory.Anytime, numberOfDigits: '5' }, defaultRegister);
var peak = __assign({ registerId: '0', timingCategory: __generated__1.SupplyPointTimingCategory.Peak, numberOfDigits: '5' }, defaultRegister);
var offpeak = __assign({ registerId: '1', timingCategory: __generated__1.SupplyPointTimingCategory.OffPeak, numberOfDigits: '5' }, defaultRegister);
var solar = __assign({ registerId: '2', timingCategory: __generated__1.SupplyPointTimingCategory.Solar, numberOfDigits: '5' }, defaultRegister);
var interval = __assign({ registerId: '3', timingCategory: __generated__1.SupplyPointTimingCategory.Interval, numberOfDigits: '5' }, defaultRegister);
var controlledLoad1 = __assign({ registerId: '4', timingCategory: __generated__1.SupplyPointTimingCategory.ControlledLoad_1, numberOfDigits: '5' }, defaultRegister);
var heat = __assign({ registerId: '5', timingCategory: __generated__1.SupplyPointTimingCategory.Heating, numberOfDigits: '5' }, defaultRegister);
var eveningWeekend = __assign({ registerId: '6', timingCategory: __generated__1.SupplyPointTimingCategory.EveningAndWeekend, numberOfDigits: '5' }, defaultRegister);
var gas = __assign(__assign({ registerId: '', timingCategory: null, numberOfDigits: '5' }, defaultRegister), { unitMeasurement: 'SCFH' });
var invalidAnytime = {
    registerId: '10',
    timingCategory: __generated__1.SupplyPointTimingCategory.Anytime,
    numberOfDigits: '5',
    registerStartDate: exports.over12MonthsReadDate,
    registerEndDate: exports.openingReadDate,
};
//==== Test Meters ====//
exports.testMeterSingleRegister = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [anytime],
};
exports.testMeterMultipleRegisters = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn2,
    status: 'active',
    registers: [peak, offpeak],
};
exports.testMeterMultipleRegistersDuplicate = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn3,
    status: 'active',
    registers: [peak, offpeak],
};
exports.testMeterSingleRegisterSolar = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsnSolar,
    status: 'active',
    registers: [solar],
};
exports.testMeterSingleRegisterRemoved = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'removed',
    registers: [anytime],
};
exports.testMeterMultipleRegistersRemoved = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'removed',
    registers: [peak, offpeak],
};
exports.testSmartMeter = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalSmartMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [anytime],
};
exports.testSmartMeterInterval = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalSmartMeterType,
    meterSerialNumber: exports.testMsn2,
    status: 'active',
    registers: [interval],
};
exports.testSmartMeterSolarInterval = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalSmartMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [solar, interval],
};
exports.testSmartMeterSolarControlledLoad1 = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalSmartMeterType,
    meterSerialNumber: exports.testMsn2,
    status: 'active',
    registers: [solar, controlledLoad1],
};
exports.testMeterGas = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsnGas,
    status: 'active',
    registers: [gas],
};
exports.testMeterHeat = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsnHeat,
    status: 'active',
    registers: [heat],
};
exports.testMeterPeakOffpeakEveningWeekend = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [peak, offpeak, eveningWeekend],
};
exports.testMeterRegisterConfigChange = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [anytime, invalidAnytime],
};
exports.testMeterRegisterConfigChangeOnlyBefore = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [invalidAnytime],
};
exports.testMeterRegisterConfigChangeOnlyAfter = {
    __typename: 'SupplyPointMeterTechnicalDetails',
    type: exports.universalTradMeterType,
    meterSerialNumber: exports.testMsn1,
    status: 'active',
    registers: [anytime],
};
//==== Test Supplies ====//
exports.testElecSupply1 = {
    sprn: exports.testSprn1,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Electricity,
    start: exports.supplyStartDate,
    end: null,
};
exports.testElecSupply1AusTimezone = __assign(__assign({}, exports.testElecSupply1), { timezone: 'Australia/Victoria' });
exports.testElecSupply2 = {
    sprn: exports.testSprn2,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Electricity,
    start: exports.supplyStartDate,
    end: null,
};
exports.testElecSupplyStartInFuture = {
    sprn: exports.testSprn1,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Electricity,
    start: exports.supplyStartDateInFuture,
    end: null,
};
exports.testElecSupplyEnd = {
    sprn: exports.testSprn1,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Electricity,
    start: exports.supplyStartDate,
    end: exports.supplyEndDate,
};
exports.testGasSupply = {
    sprn: exports.testSprnGas,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Gas,
    start: exports.supplyStartDate,
    end: null,
};
exports.testSupplyYesterday = {
    sprn: exports.testSprn1,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Electricity,
    start: exports.supplyStartDateYesterday,
    end: null,
};
exports.testSupplyYesterdayGas = {
    sprn: exports.testSprn2,
    timezone: 'Europe/London',
    fuel: __generated__1.SupplyFuel.Gas,
    start: exports.supplyStartDateYesterday,
    end: null,
};
